import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { FaPlus, FaCheck, FaHourglassHalf, FaHistory, FaTimesCircle } from "react-icons/fa";

const ReporterRaiseVoiceTabs = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const tabs = [
        { title: "New", icon: <FaPlus />, path: "/reporter/raisevoice/new" },
        { title: "Accepted", icon: <FaCheck />, path: "/reporter/raisevoice/accepted" },
        { title: "Running", icon: <FaHourglassHalf />, path: "/reporter/raisevoice/running" },
        { title: "Completed", icon: <FaHistory />, path: "/reporter/raisevoice/completed" },
        { title: "Rejected", icon: <FaTimesCircle />, path: "/reporter/raisevoice/rejected" },
    ];

    return (
        <div className="max-w-7xl mx-auto px-2 mb-6">
            <div className="flex items-center gap-1.5 overflow-x-auto pb-2 no-scrollbar">
                {tabs.map((tab, index) => {
                    const isActive = location.pathname === tab.path;
                    return (
                        <motion.button
                            key={index}
                            whileTap={{ scale: 0.95 }}
                            onClick={() => navigate(tab.path)}
                            className={`flex items-center gap-2 px-4 py-2.5 rounded-xl whitespace-nowrap transition-all duration-300 font-black text-[10px] uppercase tracking-wider border-2 ${isActive
                                    ? "bg-slate-900 border-slate-900 text-white shadow-lg shadow-slate-200"
                                    : "bg-white border-slate-100 text-slate-400 hover:border-slate-200 hover:text-slate-600"
                                }`}
                        >
                            <span className={isActive ? "text-indigo-400" : "text-slate-300"}>
                                {tab.icon}
                            </span>
                            {tab.title}
                        </motion.button>
                    );
                })}
            </div>
        </div>
    );
};

export default ReporterRaiseVoiceTabs;
